import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const images = ['https://i.postimg.cc/q7xPB7wW/Carrusel-1.webp', 'https://i.postimg.cc/fLH1Xg6K/Carrusel-2.jpg', 'https://i.postimg.cc/T1FSN52K/Carrusel-3.webp', 'https://i.postimg.cc/kXRL6sws/Carrusell-4.webp', 'https://i.postimg.cc/9QGS1f6L/Carrusell-5.webp'];
export function ImageCarouselSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  // Auto-play functionality
  useEffect(() => {
    if (isHovered) return;
    const timer = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [isHovered]);
  const goToNext = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
  };
  const goToPrev = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + images.length) % images.length);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  return <section className="py-20 bg-black/40 border-y border-white/5" data-id="element-131">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-132">
        <div className="text-center mb-12" data-id="element-133">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-134">
            Evidencia <span className="text-brand-gold" data-id="element-135">Visual</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-136">
            Resultados reales de personas que ya han transformado su salud
            capilar siguiendo el protocolo.
          </p>
        </div>

        <div className="relative w-full max-w-3xl mx-auto rounded-2xl overflow-hidden border border-white/10 shadow-[0_0_40px_rgba(0,0,0,0.5)] group bg-brand-dark" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} onTouchStart={() => setIsHovered(true)} onTouchEnd={() => setIsHovered(false)} data-id="element-137">
          {/* Aspect Ratio Container */}
          <div className="relative aspect-[4/5] sm:aspect-square md:aspect-[4/3] w-full" data-id="element-138">
            {images.map((src, index) => <img key={index} src={src} alt={`Resultado ${index + 1}`} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${index === currentIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'}`} data-id="element-139" />)}

            {/* Overlay Gradient for better dot visibility */}
            <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black/80 to-transparent z-20 pointer-events-none" data-id="element-140" />
          </div>

          {/* Navigation Arrows */}
          <button onClick={goToPrev} className="absolute left-4 top-1/2 -translate-y-1/2 z-30 p-2 rounded-full bg-black/50 text-white backdrop-blur-sm border border-white/10 opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-brand-gold hover:text-black hover:scale-110 focus:outline-none focus:ring-2 focus:ring-brand-gold md:flex hidden items-center justify-center" aria-label="Imagen anterior" data-id="element-141">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-142" />
          </button>

          <button onClick={goToNext} className="absolute right-4 top-1/2 -translate-y-1/2 z-30 p-2 rounded-full bg-black/50 text-white backdrop-blur-sm border border-white/10 opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-brand-gold hover:text-black hover:scale-110 focus:outline-none focus:ring-2 focus:ring-brand-gold md:flex hidden items-center justify-center" aria-label="Siguiente imagen" data-id="element-143">
            <ChevronRightIcon className="w-6 h-6" data-id="element-144" />
          </button>

          {/* Mobile Navigation Areas (Invisible tap targets for easier mobile swiping/tapping) */}
          <div className="absolute inset-y-0 left-0 w-1/4 z-20 md:hidden" onClick={goToPrev} data-id="element-145" />
          <div className="absolute inset-y-0 right-0 w-1/4 z-20 md:hidden" onClick={goToNext} data-id="element-146" />

          {/* Dot Indicators */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-30 flex items-center gap-3" data-id="element-147">
            {images.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`transition-all duration-300 rounded-full ${index === currentIndex ? 'w-8 h-2.5 bg-brand-gold shadow-[0_0_10px_rgba(212,175,55,0.5)]' : 'w-2.5 h-2.5 bg-white/40 hover:bg-white/80'}`} aria-label={`Ir a la imagen ${index + 1}`} data-id="element-148" />)}
          </div>
        </div>
      </div>
    </section>;
}